<template>
  <div>
    <div class="d-flex">
      <div class="field">Tipo Documento</div>
      <div class="values">Documento Tributario Electronico</div>
    </div>
    <div class="d-flex">
      <div class="field">Descripción</div>
      <div class="values">{{ dte.tipo_dte }}</div>
    </div>
    <div class="d-flex">
      <div class="field">Folio</div>
      <div class="values">{{ dte.folio }}</div>
    </div>
    <div class="d-flex">
      <div class="field">Hora y Fecha</div>
      <div class="values">{{ dte.fecha_creacion }}</div>
    </div>
    <div class="d-flex">
      <div class="field">Estado</div>
      <div v-if="dte._estado_sii" class="values">{{ dte._estado_sii }}
        <span v-if="dte._estado_sii === siiStates.created">Creado</span>
        <span
          v-else-if="dte._estado_sii === siiStates.pendingShipping">
          Pendiente de envio al sii</span>
        <span v-else-if="dte._estado_sii === siiStates.sent">Enviado al sii</span>
        <span v-else-if="dte._estado_sii === siiStates.sendError">Error al enviar</span>
        <span v-else-if="dte._estado_sii === siiStates.accepted">Aceptado por el sii</span>
        <span
          v-else-if="dte._estado_sii === siiStates.acceptedWithQualms">
          Aceptado con reparos por el sii</span>
        <span v-else-if="dte._estado_sii === siiStates.rejected">Rechazado por el sii</span>
        <span
          v-else-if="dte._estado_sii === siiStates.pendingConsultation">
          Pendiente de consulta en el sii</span>
        <span
          v-else-if="dte._estado_sii === siiStates.queryError">
          Error al consultar en el sii</span>
        <span v-else-if="dte._estado_sii === siiStates.overcast">Ensobrado</span>
        <span v-else-if="dte._estado_sii === siiStates.canceled">Anulado</span>
        <span
          v-else-if="dte._estado_sii === siiStates.pendingValidation">
          Descargado listado, pendiente validacion</span>
        <span v-else>ESTADO DESCONOCIDO</span>
      </div>
    </div>
    <div class="d-flex">
      <div class="field">Estado Comercial</div>
      <div class="values"
        v-if="dte._estado_comercial"
        >({{ dte._estado_comercial }})
        <span v-if="dte._estado_sii === commercialStatus.preAccepted">Pre Aceptado</span>
        <span v-else-if="dte._estado_sii === commercialStatus.accepted">Aceptado en el SII</span>
        <span v-else-if="dte._estado_sii === commercialStatus.preRejected">Pre Rechazado</span>
        <span v-else-if="dte._estado_sii === commercialStatus.rejected">Rechazado en el SII</span>
        <span
          v-else-if="dte._estado_sii === commercialStatus.partialClaim">
          Reclamo Parcial en el SII</span>
        <span
          v-else-if="dte._estado_sii === commercialStatus.totalClaim">
          Reclamo Total en el SII</span>
        <span
          v-else-if="dte._estado_sii === commercialStatus.receiptOfGoods"
        >
          Recibo Mercaderias en el SII
        </span>
        <span
          v-else-if="dte._estado_sii === commercialStatus.acceptedByDefault"
        >
          Aceptado Por Defecto en el SII
        </span>
        <span v-else-if="dte._estado_sii === commercialStatus.noAction">Sin Accion</span>
        <span v-else>Sin Accion</span>
      </div>
    </div>
    <div class="d-flex">
      <div class="field">Empresa Emisora</div>
      <div class="values">
        {{ formatNumber(dte.rut_emisor.split("-")[0])}}
        -
        {{ dte.rut_emisor.split("-")[1]}}
        /
        {{ dte.rzn_soc}}
      </div>
    </div>
    <div class="d-flex">
      <div class="field">Empresa receptora</div>
      <div class="values">
        {{ formatNumber(dte.rut_recep.split('-')[0])}}-{{ dte.rut_recep.split('-')[1]}}
        /
        {{ dte.rzn_soc_recep}}
      </div>
    </div>
    <div class="d-flex">
      <div class="field">Monto</div>
      <div class="values">$ {{ formatNumber(dte.mnt_total) }}</div>
    </div>
  </div>
</template>

<script>
import states from '@/febos/chile/verificarQrAprobaciones/mixins/states';

export default {
  name: 'DTE',
  props: ['dte', 'formatNumber'],
  data() {
    return {
      siiStates: states.siiStates,
      commercialStatus: states.commercialStatus,
    };
  }
};
</script>
